<template>
  <section class="">
   <form class="login" @submit.prevent="login">
    <div class="left login"><img style="float: right; margin-top: -100px;" src="/img/top_ds_left.png"></div><div class="content bcgd">
     <div class="row">
      <p class="login-brief">У Вас нет учетной записи? <router-link to="/register">Зарегистрируйтесь сейчас</router-link></p>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <label for="email">Введите логин или адрес эл.почты</label>
          <input id="email" value="" type="text" required v-model="email" />
          <label for="password">Введите пароль</label>
          <input id="password" required v-model="password" type="password" value="" />
          <a class="forgot" href="#">Забыли пароль?</a>
	<div :class="{ active: dsaveme, saveme: true }" style="height: 40px; cursor: pointer;" @click="dsaveme = !dsaveme">
	  <span class="check "></span>
	  <span style="font-size: 24px; margin-top: 4px; display: inline-block; margin-left: 20px; position: absolute; color: #454444;">Запомнить меня</span>
	</div>
          <button class="button login" value="">Войти в кабинет</button>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <label></label>
        <p></p>
      </div></div>
    </div><div class="right login"><img style="float: left; margin-top: -300px;" src="/img/top_ds_right.png"></div>
    <div class="iskaut"></div><!--<div class="iskaut-revers"></div>//-->
   </form>
  </section>


<!-- <div>
   <form class="login" @submit.prevent="login">
     <h1>Sign in</h1>
     <label>Email</label>
     <input required v-model="email" type="text" placeholder="Name"/>
     <label>Password</label>
     <input required v-model="password" type="password" placeholder="Password"/>
     <hr/>
     <button type="submit">Login</button>
   </form>
 </div>//-->
</template>
<script>
	export default {
		data(){
			return { email : "", password : "", dsaveme: false, cls: true }
		},
		methods: {
		 	login: function () {
		   		let email = this.email 
		   		let password = this.password
		   		let saveme = this.dsaveme
		   		this.$store.dispatch('login', { email, password, saveme })
		   		.then(() => this.$router.push('/secure'))
		   		.catch(err => console.log(err))
		   	}
		}
	}
/*   (function ($) {
      jQuery('.saveme').click(function () {
        if (jQuery(this).hasClass('active')) {
          jQuery(this).removeClass("active");
          jQuery('#saveme').val('0');
        } else {
          jQuery(this).addClass("active");
          jQuery('#saveme').val('1');
        }
      });
   }); */
</script>